import React from 'react';
import { Navigate } from 'react-router-dom';
import { getSessionInfo } from '../../utils/getSessionInfo';
import { useAuthenticate } from '../../hooks/useAuthenticate';

const LocationRequired = ({ children }: { children: React.ReactNode }) => {
	const isAuthenticated = useAuthenticate();
	const { locationId } = getSessionInfo();

	if (!isAuthenticated) {
		return <Navigate to="/login" />;
	}

	if (!locationId) {
		return <Navigate to="/select-location" />;
	}

	return <>{children}</>;
};

export default LocationRequired;
